import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { translate } from '../translate';

export const CustomerServiceBox = ({ cs }) => (
  <View style={styles.box}>
    <Text style={styles.rowHeader}>{translate('customerService')}</Text>
    <Text style={{}}>{cs.name}</Text>
    <Text style={{}}>{cs.phone}</Text>
    <Text style={{}}>{cs.email}</Text>
  </View>
);
